function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxiTaxiStopSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 60.601004 60.601004",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 7.7861277,56.033003 c -1.7775,0 -3.2175,-1.44125 -3.2175,-3.2175 l 0,-45.0312503 c 0,-1.77625 1.44,-3.21625 3.2175,-3.21625 l 45.0300003,0 c 1.77625,0 3.21625,1.44 3.21625,3.21625 l 0,45.0312503 c 0,1.77625 -1.44,3.2175 -3.21625,3.2175 l -45.0300003,0 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#5E4C00",
      strokeWidth: 0.60625005,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.11238,43.280502 c -1.48625,0 -2.69125,-1.20375 -2.69125,-2.69125 0,-1.48625 1.205,-2.69 2.69125,-2.69 1.4875,0 2.69125,1.20375 2.69125,2.69 0,1.4875 -1.20375,2.69125 -2.69125,2.69125 z m -19.6325,0 c -1.48625,0 -2.69125,-1.20375 -2.69125,-2.69125 0,-1.48625 1.205,-2.69 2.69125,-2.69 1.48625,0 2.69,1.20375 2.69,2.69 0,1.4875 -1.20375,2.69125 -2.69,2.69125 m 0.405,-13.93625 c 3.10625,-0.32375 6.27,-0.4875 9.41125,-0.4875 3.1425,0 6.30875,0.16375 9.415,0.4875 l 1.81625,6.32375 -22.46875,0 1.82625,-6.32375 m 22.4,6.32375 -2.2625,-7.88 c -1.79375,-0.20875 -3.6025,-0.3675 -5.425,-0.4725 l -0.945,-3.51375 -8.7125,0 -0.945,3.51375 c -1.8225,0.105 -3.63125,0.26375 -5.42375,0.4725 l -2.26375,7.88 c -1.3575,0 -2.45,1.1 -2.45,2.45875 l -0.0012,9.15875 2.4325,-0.0013 -0.0013,3.9125 c 0.59625,0.21625 1.22375,0.33375 1.89375,0.33375 0.65875,0 1.305,-0.115 1.8925,-0.32375 l 0,-3.92375 18.445,-0.0025 -0.0012,3.91625 c 0.595,0.21625 1.2225,0.33375 1.8925,0.33375 0.65875,0 1.30625,-0.115 1.8925,-0.32375 l 0,-3.92625 2.4425,-0.0025 0,-9.15125 c 0,-1.35875 -1.1025,-2.45875 -2.46,-2.45875",
    style: {
      fill: "#5E4C00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.723628,10.248 -2.9275003,0 0,-2.3500003 9.0200003,0 0,2.3500003 -2.9275,0 0,9.53 -3.165,0 0,-9.53",
    style: {
      fill: "#5E4C00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22.972379,14.995501 1.53125,-4.6475 0.03375,0 1.4125,4.6475 -2.9775,0 z m 3.505,-7.0975003 -3.88,0 -4.51,11.8800003 3.21625,0 0.93625,-2.53625 4.46,0 0.88375,2.53625 3.4725,0 -4.57875,-11.8800003",
    style: {
      fill: "#5E4C00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.71738,13.530501 -3.43875,-5.6325003 3.69375,0 1.99125,3.9150003 2.0425,-3.9150003 3.47125,0 -3.47125,5.6325003 3.81125,6.2475 -3.7775,0 -2.2975,-4.375 -2.28125,4.375 -3.59,0 3.84625,-6.2475",
    style: {
      fill: "#5E4C00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.119881,7.8979997 0,11.8800013 3.16625,0 0,-11.8800013 -3.16625,0 z",
    style: {
      fill: "#5E4C00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiTaxiStopSvgrepoCom);
export default __webpack_public_path__ + "static/media/taxi-taxi-stop-svgrepo-com.d15c152642812ce3e7f89768154b566e.svg";
export { ForwardRef as ReactComponent };